import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SolarAnnoucementsComponent } from '../dialogs/solar-annoucements/solar-annoucements.component';
// import * as newsUpdate from '../../../assets/JsonFolder/news.json';
import { HttpClient } from '@angular/common/http';
import { NewsUpdatesType } from 'src/app/shared/models/home.model';
import { UserRepositoryService } from 'src/app/services/user-repository.service';
import { takeUntil } from 'rxjs/operators';
import { HomePageContents, sectionDetails } from 'src/app/shared/models/admin.model';
import { Subject } from 'rxjs';
import { AdminRepositoryService } from 'src/app/services/admin-repository.service';
@Component({
  selector: 'app-news-updates-preview',
  templateUrl: './news-updates-preview.component.html',
  styleUrls: ['./news-updates-preview.component.scss']
})
export class NewsUpdatesPreviewComponent implements OnInit {
  public newsArray: NewsUpdatesType[];
  @Input() pageContents;
  private unsubscribe: Subject<void> = new Subject<void>();
  constructor(private httpClient: HttpClient,
    private userRepositoryService: UserRepositoryService,
    private adminRepository: AdminRepositoryService,
    private dialog: MatDialog
  ) { }
  ngOnInit() {
      // this.httpClient.get("../../../assets/JsonFolder/news.json").subscribe(data =>
      // {
      //   this.newsArray = data as NewsUpdatesType[];
      // })
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.pageContents && changes.pageContents.currentValue) {
      this.filterNewsInfo(changes.pageContents.currentValue);
      let i ;
      for(let j = 0; j < this.pageContents.length; j++  ){
        i = j+3;
        this.pageContents[j].openValue = i;
      }
    }
  }

  filterNewsInfo(response) {
    let news_updates = response.sectionDetails.filter(data => data.staticContentName == 'News & Updates Management');
   let newsupdates = response.sectionDetails.filter(data => data.staticContentName == 'NewsAndUpdatesManagement');
   //this.pageContents = news_updates.concat(newsupdates) ;
   this.pageContents = newsupdates;
   }

  onReadMoreClick(val) {
      const dialogRef = this.dialog.open(SolarAnnoucementsComponent, {
        width: '1000px',
        data: {
          panelState: val,
          pageContents: this.pageContents
        }
      });
      dialogRef.afterClosed();
  }
}
